var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReceipt = function SvgReceipt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "receipt_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#receipt_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 21.4V2.6q0-.175.15-.238.15-.061.275.063l.725.725a.48.48 0 0 0 .7 0l.8-.8a.48.48 0 0 1 .7 0l.8.8a.48.48 0 0 0 .7 0l.8-.8a.48.48 0 0 1 .7 0l.8.8a.48.48 0 0 0 .7 0l.8-.8a.48.48 0 0 1 .7 0l.8.8a.48.48 0 0 0 .7 0l.8-.8a.48.48 0 0 1 .7 0l.8.8a.48.48 0 0 0 .7 0l.8-.8a.48.48 0 0 1 .7 0l.8.8a.48.48 0 0 0 .7 0l.725-.725q.125-.125.275-.063.15.063.15.238v18.8q0 .175-.15.238-.15.061-.275-.063l-.725-.725a.48.48 0 0 0-.7 0l-.8.8a.48.48 0 0 1-.7 0l-.8-.8a.48.48 0 0 0-.7 0l-.8.8a.48.48 0 0 1-.7 0l-.8-.8a.48.48 0 0 0-.7 0l-.8.8a.48.48 0 0 1-.7 0l-.8-.8a.48.48 0 0 0-.7 0l-.8.8a.48.48 0 0 1-.7 0l-.8-.8a.48.48 0 0 0-.7 0l-.8.8a.48.48 0 0 1-.7 0l-.8-.8a.48.48 0 0 0-.7 0l-.725.725q-.125.124-.275.063Q3 21.575 3 21.4M7 17h10q.424 0 .712-.288A.97.97 0 0 0 18 16a.97.97 0 0 0-.288-.713A.97.97 0 0 0 17 15H7a.97.97 0 0 0-.713.287A.97.97 0 0 0 6 16q0 .424.287.712Q6.576 17 7 17m0-4h10q.424 0 .712-.287A.97.97 0 0 0 18 12a.97.97 0 0 0-.288-.713A.97.97 0 0 0 17 11H7a.97.97 0 0 0-.713.287A.97.97 0 0 0 6 12q0 .424.287.713Q6.576 13 7 13m0-4h10q.424 0 .712-.288A.97.97 0 0 0 18 8a.97.97 0 0 0-.288-.713A.97.97 0 0 0 17 7H7a.97.97 0 0 0-.713.287A.97.97 0 0 0 6 8q0 .424.287.712Q6.576 9 7 9M5 19.1h14V4.9H5z"
  }))));
};
export default SvgReceipt;